module.exports = __webpack_public_path__ + "static/media/capital_logo.98b123ee.png";